import { useStore } from "../../contexts/store"
import Link from "./Link"
import { Box } from "@mui/material"

const Logo = () => {
  const { uiStore } = useStore()

  function handleClick() {
    uiStore.setSidebarIsOpen(false)
  }

  return (
    <Link onClick={handleClick} noDecoration={true} to="/" sx={{
      alignItems: "center",
      display: "grid",
      gap: "10px",
      gridTemplateColumns: "min-content auto",
      minHeight: "70px",
      padding: "10px 10px 5px 30px"
    }}>
      <img src="/img/shrimpy-solo.png" style={{width:55, float:'left'}} alt="The SHRIMP Logo" />
      <Box sx={{
        fontSize: "30px",
        fontWeight: "800"
      }}>
        SHRIMP
      </Box>
    </Link>
  )
}

export default Logo